import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment featuredEventsContentBlockType on Craft_contentBlocks_FeaturedEvents_BlockType {
    uid
    typeHandle
    events {
      ...eventEntry
    }
  }
`

export const featuredEventsContentBlockType = gql`
  fragment featuredEventsContentBlockType on contentBlocks_FeaturedEvents_BlockType {
    uid
    typeHandle
    events {
      ...eventEntry
    }
  }
`
